import envConfig from '../../static/config';

let egainChatSme = {};

export const loadEGainSMEChat = () => {
  egainChatSme.egainChatParameters = {};
  // Set to true to enable posting attributes to templates.
  egainChatSme.postChatAttributes = true;
  egainChatSme.eglvchathandle = null;
  egainChatSme.liveServerURL = envConfig.eGainLiveServerURL;
  const brand =
    envConfig.brandId === 'DYB' || envConfig.brandId === 'VM'
      ? 'b'
      : envConfig.brandId.toLowerCase();
  const chatPath = `/templates/chat/secure_cyb-${brand}/chat.html?entryPointId=${envConfig.eGainEntryPointSME}&templateName=secure_cyb-${brand}&languageCode=en&countryCode=US&ver=v11&postChatAttributes=`;
  egainChatSme.openHelp = () => {
    const domainRegex = /^((?:https?:\/\/)?(?:www\.)?([^/]+))/i;
    try {
      if (
        egainChatSme.eglvchathandle != null &&
        egainChatSme.eglvchathandle.closed == false
      ) {
        egainChatSme.eglvchathandle.focus();
        return;
      }
    } catch (err) {}
    let refererName = '';
    refererName = encodeURIComponent(refererName);
    let refererurl = encodeURIComponent(document.location.href);
    const hashIndex = refererurl.lastIndexOf('#');
    if (hashIndex != -1) {
      refererurl = refererurl.substring(0, hashIndex);
    }
    const eglvcaseid = /eglvcaseid=[0-9]*/gi.exec(window.location.search);
    let vhtIds = '';
    if (typeof EGAINCLOUD != 'undefined' && EGAINCLOUD.Account.getAllIds) {
      const ids = EGAINCLOUD.Account.getAllIds();
      vhtIds = `&aId=${ids.a}&sId=${ids.s}&uId=${ids.u}`;
    }
    const EG_CALL_Q = window.EG_CALL_Q || [];
    EG_CALL_Q.push(['enableTracker', true]);
    let eGainChatUrl = `${
      egainChatSme.liveServerURL + chatPath + egainChatSme.postChatAttributes
    }&eglvrefname=${refererName}&${eglvcaseid}${vhtIds}`;
    const domain = domainRegex.exec(eGainChatUrl)[0];
    if (
      window.navigator.userAgent.indexOf('Trident') != -1 &&
      egainChatSme.postChatAttributes
    ) {
      const win = document.getElementById('egainChatDomainFrame');
      win.contentWindow.postMessage(
        JSON.stringify(egainChatSme.egainChatParameters),
        domain
      );
    }
    if ((eGainChatUrl + refererurl).length <= 2000)
      eGainChatUrl += `&referer=${refererurl}`;
    const params =
      'height=650,width=450,resizable=yes,scrollbars=yes,toolbar=no';
    if (egainChatSme.postChatAttributes)
      egainChatSme.storeChatParameters('eGainChatIdentifier', 'true');
    egainChatSme.eglvchathandle = window.open(eGainChatUrl, '', params);
    /* Message posted to the child window every second until it sends a message in return. This is done as we can not be sure when the mssage listener will be set in the child window.*/
    if (
      window.navigator.userAgent.indexOf('Trident') == -1 &&
      egainChatSme.postChatAttributes
    ) {
      const messagePostInterval = setInterval(() => {
        const message = egainChatSme.egainChatParameters;
        egainChatSme.eglvchathandle.postMessage(message, domain);
      }, 1000);
      window.addEventListener(
        'message',
        (event) => {
          if (event.data.chatParametersReceived) {
            clearInterval(messagePostInterval);
          }
        },
        false
      );
    }
  };
  /* To be called by client website. All the parameters specified in eGainLiveConfig must be set here.*/
  egainChatSme.storeChatParameters = (attributeName, attributeValue) => {
    egainChatSme.egainChatParameters[attributeName] = attributeValue;
  };
  egainChatSme.writeIframeIfRequired = () => {
    if (
      egainChatSme.postChatAttributes &&
      window.navigator.userAgent.indexOf('Trident') !== -1
    ) {
      const iframe = document.createElement('iframe');
      iframe.src = `${egainChatSme.liveServerURL}/web/view/live/customer/storeparams.html`;
      iframe.style.display = 'none';
      iframe.name = 'egainChatDomainFrame';
      iframe.id = 'egainChatDomainFrame';
      document.body.appendChild(iframe);
    }
  };
  egainChatSme.writeIframeIfRequired();
  return egainChatSme;
};

export const getSMEChat = () => egainChatSme;
